import React from 'react'
import Loader from '../images/Loader.gif';


const Loading =()=> {
  return (

	
    <div>
      <img src={Loader} alt="Description of the GIF" style={{width:"200px"}}/>
    </div>
  )
}



export default Loading
